import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { forwardRef, useMemo } from "react";
import { MetadataInputProps } from "../metadata-input-index";
import GlobalConst from "../../../Core/Utils/Constants/globals";
import dayjs from "dayjs";

export type LocalizedDateTimeMetadataInfos = {
  cultureId: number;
  language: string;
  value: Date;
  epNb: number | null;
};

type LocalizedDateTimeMetadataInfosIndexed = {
  index: number;
  data: LocalizedDateTimeMetadataInfos;
};

const MetadataInputDateMultiLocalized = forwardRef<any, MetadataInputProps>((props, ref) => {
  const { onChange, data, value, cultureId, dateRange, epNb = null } = props;

  const localized = useMemo((): LocalizedDateTimeMetadataInfosIndexed => {
    return {
      index: (value as LocalizedDateTimeMetadataInfos[]).findIndex((x) => x.cultureId === cultureId && x.epNb === epNb),
      data: (value as LocalizedDateTimeMetadataInfos[]).find((x) => x.cultureId === cultureId && x.epNb === epNb)!,
    };
  }, [value, cultureId, epNb]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        value={localized && localized.data && localized.data.value ? dayjs(localized.data.value) : dayjs("")}
        onChange={(v, e) => {
          onChange(
            { ...localized.data, value: e.validationError !== null ? null : v },
            data.id,
            localized.index >= 0 ? localized.index : value.length
          );
        }}
        format={GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS}
        //renderInput={(params) => <TextField sx={{ mt: "-24px" }} {...params} />}
      />
    </LocalizationProvider>
  );
});

export default MetadataInputDateMultiLocalized;
